module.exports = __webpack_public_path__ + "static/media/AR21_shareholders.034ccac8.jpg";